import {
  WSCard,
  WSElement,
  WSSectionToolbar,
  WSText
} from "@wingspanhq/fe-component-library";
import { IWorkLog } from "@wingspanhq/payments/dist/interfaces";
import React from "react";
import { FilesTable } from "../../../Files/components/FilesTable";
import styles from "./WorkLogAdditionalDetails.module.scss";

type Props = {
  workLog?: IWorkLog;
  shimmer?: boolean;
  overlay?: boolean;
};

export const WorkLogAdditionalDetails: React.FC<Props> = ({
  workLog,
  shimmer,
  overlay
}) => {
  const attachmentIds = workLog?.attachmentIds || [];
  const hasNotes = !!workLog?.notes;
  const hasAttachments = attachmentIds.length > 0;

  if (shimmer) {
    return (
      <WSElement>
        <WSSectionToolbar title="Additional details" />
        <WSElement className={overlay ? styles.overlayContainer : undefined}>
          {overlay && <WSElement className={styles.overlay} />}
          <WSCard mt="M" shimmer />
        </WSElement>
      </WSElement>
    );
  }

  // Hide entire widget if both notes and attachments are empty
  if (!hasNotes && !hasAttachments) {
    return null;
  }

  return (
    <WSElement>
      <WSSectionToolbar title="Additional details" />
      <WSElement className={overlay ? styles.overlayContainer : undefined}>
        {overlay && <WSElement className={styles.overlay} />}
        <WSCard mt="M">
          {/* Notes Section - only show if has notes */}
          {hasNotes && (
            <WSElement>
              <WSText.ParagraphSm color="gray500" mb="XS">
                Notes (optional)
              </WSText.ParagraphSm>
              <WSText.ParagraphSm color="gray700">
                {workLog?.notes}
              </WSText.ParagraphSm>
            </WSElement>
          )}

          {/* Attachments Section - only show if has attachments */}
          {hasAttachments && (
            <WSElement mt={hasNotes ? "XL" : undefined}>
              <WSText.ParagraphSm color="gray500" mb="S">
                Attachments (optional)
              </WSText.ParagraphSm>
              <FilesTable fileIds={attachmentIds} />
            </WSElement>
          )}
        </WSCard>
      </WSElement>
    </WSElement>
  );
};
